module.exports = __webpack_public_path__ + "static/media/TS.94df2cd3.webp";